import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaginationPipe } from './pagination/pagination.pipe';
import { ProfilePicturePipe } from './profilePicture/profilePicture.pipe';
import { ChatPersonSearchPipe } from './search/chat-person-search.pipe';
import { UserSearchPipe } from './search/user-search.pipe';
import { TruncatePipe } from './truncate/truncate.pipe';
import { MailSearchPipe } from './search/mail-search.pipe';
import { SafeHtmlPipe } from './safeHtml/safeHtml.pipe';
import { FilterPipe } from './search/filter.pipe';
import { FullUrlPipe } from './fullUrl/fullUrl.pipe';
import { ResourcesUrlPipe } from './resourcesUrl/resources-url.pipe';
import { SchoolBagSearchPipe } from './search/school-bag-search.pipe';
import { GroupSearchPipe } from './search/group-search.pipe';
import { SafeUrlPipe } from './safeUrl/safe-url.pipe';
import { InitialsPipe } from './initials/initials.pipe';
import { RoundPipe } from './round/round.pipe';
import { ThumbnailUrlPipe } from './thumbnailUrl/thumbnail-url.pipe';
import { WeeklyPlanSearchPipe } from './search/weekly-plan-search.pipe';
import { BehaviourPlanSearch } from './search/behaviour-plan-search.pipe.pipe';
import { DefaultUserFullUrlPipe } from './defaultUserFullUrl/default-user-full-url.pipe';
import { SubsubjectSearch } from './search/subsubject-search.pipe';
import { OptionsSearchPipe } from './search/options-search.pipe';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        PaginationPipe,
        ProfilePicturePipe,
        ChatPersonSearchPipe,
        UserSearchPipe,
        TruncatePipe,
        MailSearchPipe,
        SafeHtmlPipe,
        FilterPipe,
        FullUrlPipe,
        ResourcesUrlPipe,
        SchoolBagSearchPipe,
        GroupSearchPipe,
        SafeUrlPipe,
        InitialsPipe,
        RoundPipe,
        ThumbnailUrlPipe,
        WeeklyPlanSearchPipe,
        BehaviourPlanSearch,
        DefaultUserFullUrlPipe,
        SubsubjectSearch,
        OptionsSearchPipe
    ],
    exports: [
        PaginationPipe,
        ProfilePicturePipe,
        ChatPersonSearchPipe,
        UserSearchPipe,
        TruncatePipe,
        MailSearchPipe,
        SafeHtmlPipe,
        FilterPipe,
        FullUrlPipe,
        ResourcesUrlPipe,
        SchoolBagSearchPipe,
        GroupSearchPipe,
        SafeUrlPipe,
        InitialsPipe,
        RoundPipe,
        ThumbnailUrlPipe,
        WeeklyPlanSearchPipe,
        BehaviourPlanSearch,
        DefaultUserFullUrlPipe,
        SubsubjectSearch,
        OptionsSearchPipe
    ]
})
export class PipesModule { }
